export default "__VITE_ASSET__y9v1$aHd__"